export default __webpack_public_path__ + "static/media/consol-3-en.7882a55d.svg";